import { Component, OnInit } from '@angular/core';
import { Details }    from '../login/details';
import {LoginService} from '../login.service';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  edit:Boolean = true;
  visible:Boolean = false;
  public details=new Details('','','','','','','','','','','','',null,{question:'Choose One Question',answer:''},{question:'Choose One Question',answer:''},{question:'Choose One Question',answer:''},false,'');
  currentPassword:any;
  newPassword:any;
  confirmPassword:any;
  questions:any=[];
  questions1:any=[];
  questions2:any=[];
  questions3:any=[];
  security1:Boolean = false;
  security2:Boolean = false;
  security3:Boolean = false;
  security4:Boolean = false;
  security5:Boolean = false;
  changePassworderror:Boolean = true;
  errorMessage:any;

  constructor(public loginService:LoginService, public toastService:ToastrService,private datePipe: DatePipe) { }

  ngOnInit() {
    this.loginService.getSecurityQuestions().subscribe((data)=>{
      this.questions = data;
      this.questions1 = this.questions.slice();
      this.questions2 = this.questions.slice();
      this.questions3 = this.questions.slice();
    },error=>{
      this.toastService.error("Unable to profile Information","My Profile");
    });
    this.loginService.getuser(this.loginService.personId).subscribe((data:Details)=>{
      if(data != null){
        this.details = data;
        this.details.dob = this.datePipe.transform(this.details.dob, 'MM/dd/yyyy');
      this.details.security1 = JSON.parse(CryptoJS.AES.decrypt(this.details.security1.toString(), "security").toString(CryptoJS.enc.Utf8));
      this.details.security2 = JSON.parse(CryptoJS.AES.decrypt(this.details.security2.toString(), "security").toString(CryptoJS.enc.Utf8));
      this.details.security3 = JSON.parse(CryptoJS.AES.decrypt(this.details.security3.toString(), "security").toString(CryptoJS.enc.Utf8));
      this.details.password = atob(data.password);
        this.details.password1 = atob(data.password1);
        this.details.password2 = atob(data.password2);
        this.details.password3 = atob(data.password3);
        this.details.password4 = atob(data.password4);
        this.details.password5 = atob(data.password5);
      }
      else{
        this.toastService.error("Unable to profile Information","My Profile");
      }
    },error=>{
      this.toastService.error("Unable to profile Information","My Profile");
    })
  }
  toggle(){
    this.visible = !this.visible;
  }
  updateQuestions(){
    this.questions1 = this.questions.filter(question => question.description.trim() !== this.details.security2.question && question.description.trim() !== this.details.security3.question);
    this.questions2 = this.questions.filter(question => question.description.trim() !== this.details.security1.question && question.description.trim() !== this.details.security3.question);
    this.questions3 = this.questions.filter(question => question.description.trim() !== this.details.security1.question && question.description.trim() !== this.details.security2.question);
  }
  securityValidate1(){
    if(this.details.security1.question.trim() == "Choose One Question"){
      this.details.security1.answer = "";
    }
  }
  securityValidate2(){
    if(this.details.security2.question.trim() == "Choose One Question"){
      this.details.security2.answer = "";
    }
  }
  securityValidate3(){
    if(this.details.security3.question.trim() == "Choose One Question"){
      this.details.security3.answer = "";
    }
  }
  validate(){
    if(this.details.dob !== undefined && this.details.dob !== null){
      if(!(parseInt(this.details.dob.substring(0, 2)) <= 12 && parseInt(this.details.dob.substring(2, 4)) <=31 )){
        this.details.dob = null;
      }
    }
    if(this.confirmPassword !== undefined && this.confirmPassword !== null){
      if(this.confirmPassword != this.newPassword){
        this.newPassword = null;
      }
    }
  }
  submit(event){
    event.preventDefault();
    this.details.dob = this.datePipe.transform(this.details.dob, 'yyyy-MM-dd');
    let key = sha256(ServerConstantsService.serverConstants.privateKey);
    let encrypted = CryptoJS.AES.encrypt(JSON.stringify(this.details),key.toString());
    let request = {
      details:encrypted.toString()
    }
    this.loginService.updateuser(this.loginService.personId,request).subscribe((data)=>{
      if(data["affectedRows"]>0){
        this.toastService.success("Updated details successfully.",'Profile Management');
        this.ngOnInit();
        this.edit = true;
      }
      else{
        this.toastService.error('Record not saved: Please review or contact Help Desk','My Profile');
      }
    },error=>{
      this.toastService.error('Record not saved: Please review or contact Help Desk','My Profile');
    })
  }
  changePassword(){
    if(this.details.password !== this.currentPassword){
      this.changePassworderror = false;
      this.errorMessage = "Invalid Current Password";
    }
    else if (this.newPassword !== this.confirmPassword){
      this.changePassworderror = false;
      this.errorMessage = "Passwords does not match";
    }
    else if (this.changePassworderror == false){
      this.errorMessage = this.errorMessage;
    }
    else{
      this.details.password5 = this.details.password4;
      this.details.password4 = this.details.password3;
      this.details.password3 = this.details.password2;
      this.details.password2 = this.details.password1;
      this.details.password1 = this.details.password;
      this.details.password = this.newPassword;
      this.details.passwordChange = true;
      this.details.dob = this.datePipe.transform(this.details.dob, 'yyyy-MM-dd');
      let key = sha256(ServerConstantsService.serverConstants.privateKey);
      let encrypted = CryptoJS.AES.encrypt(JSON.stringify(this.details),key.toString());
      let request = {
        details:encrypted.toString()
      }
      this.loginService.updateuser(this.loginService.personId,request).subscribe((data)=>{
        if(data["affectedRows"]>0){
          this.edit = true;
          this.toastService.success("Updated password successfully.",'Password Management');
          this.currentPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';
          $('#closemodal').click();
          this.details.dob = this.datePipe.transform(this.details.dob, 'MM/dd/yyyy');
        }
        else{
          this.toastService.error('Record not saved: Please review or contact Help Desk','My Profile');
          this.details.dob = this.datePipe.transform(this.details.dob, 'MM/dd/yyyy');
        }
      },error=>{
        this.toastService.error('Record not saved: Please review or contact Help Desk','My Profile');
        this.details.dob = this.datePipe.transform(this.details.dob, 'MM/dd/yyyy');
      })
    }
  }
  validation(){
    if(!(/[a-z]/g.test(this.newPassword))){
      this.changePassworderror = false;
      this.errorMessage = "Password must contain one lowercase letter.";
    }
    else if(!(/[A-Z]/g.test(this.newPassword))){
      this.changePassworderror = false;
      this.errorMessage = "Password must contain one uppercase letter.";
    }
    else if(!(/[0-9]/g.test(this.newPassword))){
      this.changePassworderror = false;
      this.errorMessage = "Password must contain one numeric.";
    }
    else if(!(/[!@#$%\^&*)(+=._-]/g.test(this.newPassword))){
      this.changePassworderror = false;
      this.errorMessage = "Password must contain one special character.";
    }
    else if(this.newPassword.length <8){
      this.changePassworderror = false;
      this.errorMessage = "Minimum length for password is 8.";
    }
    else if(this.newPassword == this.details.password || this.newPassword == this.details.password1 || this.newPassword == this.details.password2 || this.newPassword == this.details.password3
      || this.newPassword == this.details.password4 || this.newPassword == this.details.password5){
        this.changePassworderror = false;
      this.errorMessage = "You should not use previous 6 passwords.";
      }
    else{
      this.changePassworderror = true;
      this.errorMessage = "";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts